import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "bg-dark-secondary rounded-lg p-6 mb-8" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "overflow-x-auto" }
const _hoisted_9 = { class: "bg-dark-secondary rounded-xl shadow-lg" }
const _hoisted_10 = { class: "min-w-full" }
const _hoisted_11 = { class: "divide-y divide-gray-700/50" }
const _hoisted_12 = {
  key: 1,
  class: "hover:bg-gray-700/20 transition-colors"
}
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-300" }
const _hoisted_14 = { class: "px-6 py-4 text-sm text-gray-300" }
const _hoisted_15 = { class: "font-medium text-white" }
const _hoisted_16 = { class: "text-xs text-gray-500" }
const _hoisted_17 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-300" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "px-6 py-4 text-sm text-gray-300" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "px-4 py-4 whitespace-nowrap text-right text-sm" }
const _hoisted_23 = { class: "flex items-center gap-2 justify-end" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_27 = { class: "flex justify-between items-start" }
const _hoisted_28 = { class: "text-white font-medium" }
const _hoisted_29 = { class: "text-white text-lg" }
const _hoisted_30 = { class: "bg-dark p-4 rounded-lg border border-gray-700" }
const _hoisted_31 = { class: "text-gray-200 whitespace-pre-wrap" }
const _hoisted_32 = { class: "flex justify-between text-xs text-gray-500 pt-4 border-t border-gray-700" }
const _hoisted_33 = { class: "space-y-4" }
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "mt-6 space-y-4"
}
const _hoisted_36 = { class: "p-4 bg-primary/5 border border-primary/20 rounded-lg" }
const _hoisted_37 = { class: "text-gray-200" }
const _hoisted_38 = {
  key: 1,
  class: "p-3 bg-red-500/10 border border-red-500/20 rounded-md"
}
const _hoisted_39 = { class: "text-sm text-red-400" }
const _hoisted_40 = { class: "flex gap-3" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, computed, onMounted } from 'vue'
import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'
import { useOrgStore } from '@/stores/org'
import { useProductStore } from '@/stores/products'
import BaseModal from '@/components/ui/BaseModal.vue'
import { Timestamp } from 'firebase/firestore'


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQsView',
  setup(__props) {

const orgStore = useOrgStore()
const productStore = useProductStore()

const faqs = ref<any[]>([])
const loading = ref(true)
const searchTerm = ref('')

const showDetailsModal = ref(false)
const selectedFAQ = ref<any>(null)

const showTestModal = ref(false)
const isTesting = ref(false)
const testError = ref('')
const testResult = ref<any>(null)
const testForm = ref({
  product_handle: '',
  query: ''
})

const fetchFAQs = async () => {
  try {
    loading.value = true
    const getFAQsFn = httpsCallable(functions, 'getFAQs')
    const result = await getFAQsFn()
    const data = result.data as { success: boolean; faqs: any[] }
    if (data.success) {
      faqs.value = data.faqs
    }
  } catch (error) {
    console.error('Error fetching FAQs:', error)
  } finally {
    loading.value = false
  }
}

const filteredFAQs = computed(() => {
  if (!searchTerm.value) return faqs.value
  const term = searchTerm.value.toLowerCase()
  return faqs.value.filter(faq => 
    faq.query.toLowerCase().includes(term) || 
    faq.product_title.toLowerCase().includes(term) ||
    faq.product_handle.toLowerCase().includes(term) ||
    faq.answer.toLowerCase().includes(term)
  )
})

const handleTestFAQ = async () => {
  if (!testForm.value.product_handle || !testForm.value.query) return
  
  isTesting.value = true
  testError.value = ''
  testResult.value = null

  try {
    // We use fetch for the onRequest function
    const isDev = process.env.NODE_ENV === 'development'
    const baseUrl = isDev 
      ? 'http://127.0.0.1:5001/search-plus-3bf60/australia-southeast1/askFAQ' 
      : 'https://australia-southeast1-search-plus-3bf60.cloudfunctions.net/askFAQ'

    const queryParams = new URLSearchParams({
      query: testForm.value.query,
      org_id: orgStore.orgData?.id || '',
      product_handle: testForm.value.product_handle
    })

    const response = await fetch(`${baseUrl}?${queryParams}`)

    const data = await response.json()
    if (data.success) {
      testResult.value = data.data
      fetchFAQs() // Refresh list to show new FAQ
    } else {
      testError.value = data.message || 'Failed to generate answer'
    }
  } catch (error) {
    console.error('Error testing FAQ:', error)
    testError.value = 'An error occurred while generating the answer'
  } finally {
    isTesting.value = false
  }
}

const handleDeleteFAQ = async (faq: any) => {
  if (!confirm('Are you sure you want to delete this FAQ?')) return

  try {
    const deleteFAQFn = httpsCallable(functions, 'deleteFAQ')
    await deleteFAQFn({ faq_id: faq.id })
    faqs.value = faqs.value.filter(f => f.id !== faq.id)
    if (selectedFAQ.value?.id === faq.id) {
      showDetailsModal.value = false
    }
  } catch (error) {
    console.error('Error deleting FAQ:', error)
    alert('Failed to delete FAQ')
  }
}

const openDetailsModal = (faq: any) => {
  selectedFAQ.value = faq
  showDetailsModal.value = true
}

const formatDate = (date: any) => {
  if (!date) return ''
  const dateObj = date instanceof Timestamp ? date.toDate() : 
                  (date._seconds ? new Date(date._seconds * 1000) : new Date(date))
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(dateObj)
}

const formatQueryType = (type: string) => {
  if (!type) return 'Other'
  return type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
}

const getQueryTypeClass = (type: string) => {
  switch (type) {
    case 'size_fit': return 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
    case 'colours': return 'bg-purple-500/10 text-purple-400 border border-purple-500/20'
    case 'fabric': return 'bg-green-500/10 text-green-400 border border-green-500/20'
    case 'returns': return 'bg-red-500/10 text-red-400 border border-red-500/20'
    case 'activity_use_cases': return 'bg-yellow-500/10 text-yellow-400 border border-yellow-500/20'
    case 'price_discounting_packs': return 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20'
    case 'product_search': return 'bg-indigo-500/10 text-indigo-400 border border-indigo-500/20'
    default: return 'bg-gray-500/10 text-gray-400 border border-gray-500/20'
  }
}

onMounted(async () => {
  await Promise.all([
    fetchFAQs(),
    productStore.fetchProducts()
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-4" }, "Product FAQs"),
          _createElementVNode("p", { class: "text-gray-400" }, "View and manage questions asked about your products")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showTestModal.value = true)),
            class: "inline-flex items-center gap-2 rounded-lg border border-primary/30 bg-primary/10 px-4 py-2 text-sm font-medium text-primary hover:bg-primary/20 transition-colors"
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
              })
            ], -1),
            _createTextVNode(" Test FAQ ")
          ])),
          _createElementVNode("button", {
            onClick: fetchFAQs,
            class: "inline-flex items-center gap-2 rounded-lg border border-gray-700 bg-dark px-4 py-2 text-sm font-medium text-gray-300 hover:border-primary/30 hover:bg-primary/10 hover:text-primary transition-colors",
            disabled: loading.value
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["h-4 w-4", { 'animate-spin': loading.value }]),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              }, null, -1)
            ]), 2)),
            _createTextVNode(" " + _toDisplayString(loading.value ? 'Refreshing...' : 'Refresh'), 1)
          ], 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 text-gray-400",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ])
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event)),
          type: "search",
          class: "block w-full rounded-lg border border-gray-700 bg-dark pl-10 pr-3 py-2 text-sm text-gray-100 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary",
          placeholder: "Search questions or products..."
        }, null, 512), [
          [_vModelText, searchTerm.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "border-b border-gray-700" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase"
              }, " Time "),
              _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase"
              }, " Product "),
              _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase"
              }, " Type "),
              _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase"
              }, " Question "),
              _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase"
              }, " Answer "),
              _createElementVNode("th", {
                scope: "col",
                class: "px-4 py-4 text-right text-xs font-medium text-gray-300 uppercase"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_11, [
            (loading.value && !faqs.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                  return _createElementVNode("tr", {
                    key: `skeleton-${i}`
                  }, _cache[12] || (_cache[12] = [
                    _createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-24" })
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-32" })
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-48" })
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-64" })
                    ], -1),
                    _createElementVNode("td", { class: "px-4 py-4 text-right" }, [
                      _createElementVNode("div", { class: "h-8 w-8 bg-gray-700/50 rounded-lg animate-pulse ml-auto" })
                    ], -1)
                  ]))
                }), 64))
              : (!filteredFAQs.value.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _cache[13] || (_cache[13] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "px-6 py-8 text-sm text-gray-500 text-center"
                    }, " No FAQs found ", -1)
                  ])))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredFAQs.value, (faq) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: faq.id,
                      class: "hover:bg-gray-700/20 transition-colors"
                    }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(formatDate(faq.created_at)), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(faq.product_title), 1),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(faq.product_handle), 1)
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", getQueryTypeClass(faq.query_type)])
                        }, _toDisplayString(formatQueryType(faq.query_type)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("div", {
                          class: "max-w-xs truncate",
                          title: faq.query
                        }, _toDisplayString(faq.query), 9, _hoisted_19)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", {
                          class: "max-w-md line-clamp-2",
                          title: faq.answer
                        }, _toDisplayString(faq.answer), 9, _hoisted_21)
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openDetailsModal(faq)),
                            class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-700 text-gray-300 hover:border-primary/30 hover:bg-primary/10 hover:text-primary transition-colors",
                            title: "View Details"
                          }, _cache[14] || (_cache[14] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-4 w-4",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              }),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              })
                            ], -1)
                          ]), 8, _hoisted_24),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (handleDeleteFAQ(faq)),
                            class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-red-500/30 text-red-500 hover:border-red-500/50 hover:bg-red-500/10 transition-colors",
                            title: "Delete FAQ"
                          }, _cache[15] || (_cache[15] = [
                            _createElementVNode("svg", {
                              class: "h-4 w-4",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_25)
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(BaseModal, {
      modelValue: showDetailsModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDetailsModal).value = $event)),
      "max-width": "50rem"
    }, {
      title: _withCtx(() => _cache[17] || (_cache[17] = [
        _createTextVNode("FAQ Details")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetailsModal.value = false)),
          class: "px-4 py-2 text-sm font-medium text-gray-300 hover:text-white"
        }, "Close")
      ]),
      default: _withCtx(() => [
        (selectedFAQ.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-1" }, "Product", -1)),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(selectedFAQ.value.product_title) + " (" + _toDisplayString(selectedFAQ.value.product_handle) + ")", 1)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-xs font-medium", getQueryTypeClass(selectedFAQ.value.query_type)])
                }, _toDisplayString(formatQueryType(selectedFAQ.value.query_type)), 3)
              ]),
              _createElementVNode("div", null, [
                _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-1" }, "Question", -1)),
                _createElementVNode("p", _hoisted_29, _toDisplayString(selectedFAQ.value.query), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-1" }, "Answer", -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", _hoisted_31, _toDisplayString(selectedFAQ.value.answer), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", null, "ID: " + _toDisplayString(selectedFAQ.value.id), 1),
                _createElementVNode("span", null, "Asked on: " + _toDisplayString(formatDate(selectedFAQ.value.created_at)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(BaseModal, {
      modelValue: showTestModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showTestModal).value = $event)),
      "max-width": "40rem"
    }, {
      title: _withCtx(() => _cache[21] || (_cache[21] = [
        _createTextVNode("Test FAQ Generation")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showTestModal.value = false)),
            class: "px-4 py-2 text-sm font-medium text-gray-300 hover:text-white"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: handleTestFAQ,
            disabled: isTesting.value || !testForm.value.product_handle || !testForm.value.query,
            class: "inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90 disabled:opacity-50 transition-colors"
          }, [
            (isTesting.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_42, _cache[26] || (_cache[26] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(isTesting.value ? 'Generating...' : 'Generate Answer'), 1)
          ], 8, _hoisted_41)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Select Product", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((testForm.value.product_handle) = $event)),
              class: "w-full bg-dark border border-gray-700 rounded-lg px-3 py-2 text-white focus:border-primary focus:outline-none"
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Select a product...", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: product.id,
                  value: product.handle
                }, _toDisplayString(product.title), 9, _hoisted_34))
              }), 128))
            ], 512), [
              [_vModelSelect, testForm.value.product_handle]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Question", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((testForm.value.query) = $event)),
              rows: "3",
              class: "w-full bg-dark border border-gray-700 rounded-lg px-3 py-2 text-white focus:border-primary focus:outline-none",
              placeholder: "e.g. Is this product waterproof?"
            }, null, 512), [
              [_vModelText, testForm.value.query]
            ])
          ]),
          (testResult.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "text-sm font-medium text-primary mb-2" }, "Generated Answer:", -1)),
                  _createElementVNode("p", _hoisted_37, _toDisplayString(testResult.value.answer), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (testError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("p", _hoisted_39, _toDisplayString(testError.value), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})